import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetConsultBannerQueryResponse, GetConsultBanner400, GetConsultBanner500 } from "../types/GetConsultBanner";

export const getConsultBannerQueryKey = () =>     [{url:`/api/mainPage/consultBanner`}] as const;
      export function getConsultBannerQueryOptions <TData = GetConsultBannerQueryResponse, TError = GetConsultBanner400 | GetConsultBanner500>(options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getConsultBannerQueryKey();

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/mainPage/consultBanner`,
              
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @summary Получение баннера формы консультации
 * @link /api/mainPage/consultBanner
 */

export function useGetConsultBanner <TData = GetConsultBannerQueryResponse, TError = GetConsultBanner400 | GetConsultBanner500>(options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getConsultBannerQueryKey();

  const query = useQuery<TData, TError>({
    ...getConsultBannerQueryOptions<TData, TError>(clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
